/*
 * @@Author: MuYang
 */

import batchHandleUrl from '../../utils/url-handle'

const Api = {
  // 查找关联主从列设置
  getChoiceFieldList: {
    url: '/apaas/field/getChoiceFieldList',
    type: 'post'
  }
}

export default batchHandleUrl(Api)
